import __request__ from "routing/request";
export function list() {
  return __request__("GET", "/system/indices/rotation/strategies", null, {}, {
    "Accept": ["application/json"]
  });
}
export function configSchema(strategy) {
  return __request__("GET", `/system/indices/rotation/strategies/${strategy}`, null, {}, {
    "Accept": ["application/json"]
  });
}
